// Tooltips
$(document).ready(function () {
  $(".tooltipper").tooltip();
});
